import {Poly} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/Poly';
import {PolyNodeController} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/nodes/utils/poly/PolyNodeController';
import {NodeContext} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {AllRegister} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/poly/registers/All';
import {AllModulesRegister} from '../../polygonjs-editor/@polygonjs/polygonjs/src/engine/poly/registers/modules/All';
import {FilesRegister} from '../../polygonjs-editor/src/editor/self_contained/FilesRegister';

// THOSE SHOULD NOT BE ON THE ONLINE DEMO ANYWAY!
// NOT UNTIL I CAN EXPORT THEM WITH HTML
// Although compile time is really really long with those
// import {polyPluginMapbox} from '@polygonjs/plugin-mapbox/src/index';
// import {polyPluginOcclusion} from '@polygonjs/plugin-occlusion/src/index';
// import {polyPluginPalette} from '@polygonjs/plugin-palette/src/index';
// import {polyPluginPhysics} from '@polygonjs/plugin-physics/src/index';
// function registerPluginsForLocalTests() {
// 	// const integrations_element = document.getElementById('integrations-data');
// 	// if (!integrations_element) {
// 	// 	console.error('DEV: integration-data element not found');
// 	// }
// 	// const token = integrations_element?.dataset['mapboxToken'];
// 	// if (token) {
// 	// 	polyPluginMapbox.setToken(token);
// 	// }
// 	// Poly.registerPlugin(polyPluginMapbox as any);
// 	// Poly.registerPlugin(polyPluginOcclusion as any); // this is fucking terrible
// 	// Poly.registerPlugin(polyPluginPalette as any);
// 	// Poly.registerPlugin(polyPluginPhysics as any);
// }

// if (process.env.NODE_ENV == 'development') {
// 	registerPluginsForLocalTests();
// }

export class EngineExtendedAllRegister {
	private static _started = false;
	static run() {
		if (this._started) {
			return;
		}
		this._started = true;
		AllRegister.run();
		AllModulesRegister.run(Poly);
		FilesRegister.init();

		// register local expression
		// local expression should only be registered for the desktop app
		// if registered for the web version, it then imports DesktopController
		// which in turns imports the Editor.
		// Poly.instance().expressions_register.register_expression(
		// 	LocalExpression,
		// 	"local"
		// );
		// this._set_asset_expression_resolver();

		// register poly nodes from dom elements
		// load poly_nodes
		const poly_node_elements = document.querySelectorAll('[data-poly-node]');
		for (let i = 0; i < poly_node_elements.length; i++) {
			const element = poly_node_elements[i] as HTMLElement;
			const type = element.dataset['type'];
			const node_context = element.dataset['nodeContext'];
			const definition_str = element.dataset['definition'];
			if (type && node_context && definition_str) {
				try {
					const definition = JSON.parse(definition_str);
					const node_class = PolyNodeController.createNodeClass(
						type,
						node_context as NodeContext,
						definition
					);
					if (node_class) {
						Poly.registerNode(node_class, 'poly_nodes');
					}
				} catch (e) {
					console.warn(`could not load poly node ${name}`);
				}
			}
		}
	}
	// static _set_asset_expression_resolver() {
	// 	const asset_method_class = Poly.expressionsRegister.get_method(
	// 		"asset"
	// 	);
	// 	if (asset_method_class) {
	// 		asset_method_class.set_url_resolver(async (args) => {
	// 			const saved_scene_endpoint = `/api/scenes/${args.scene_uuid}/uploads/${args.asset_name}`;
	// 			const new_scene_endpoint = `/api/uploads/${args.asset_name}`;
	// 			const api_url = args.scene_uuid
	// 				? saved_scene_endpoint
	// 				: new_scene_endpoint;
	// 			const response = await fetch(api_url);
	// 			const json = await response.json();
	// 			return json.url;
	// 		});
	// 	} else {
	// 		console.log("no asset method found");
	// 	}
	// }
}
